import DOMPurify from "dompurify";

const stripControlChars = (value: string) =>
  Array.from(value)
    .filter((char) => {
      const code = char.charCodeAt(0);
      return !((code >= 0 && code <= 8) || code === 11 || code === 12 || (code >= 14 && code <= 31) || code === 127);
    })
    .join("");

export const sanitizeText = (value: unknown, maxLength = 1_000) => {
  const clean = DOMPurify.sanitize(String(value ?? ""), {
    ALLOWED_TAGS: [],
    ALLOWED_ATTR: [],
  });
  const cleanWithoutControlChars = stripControlChars(clean);
  return cleanWithoutControlChars.length > maxLength ? cleanWithoutControlChars.slice(0, maxLength) : cleanWithoutControlChars;
};

export const sanitizeOptionalText = (value: unknown, maxLength = 1_000) => {
  const clean = sanitizeText(value, maxLength).trim();
  return clean || undefined;
};
